import React from "react"
import { Chip, useTheme } from "react-native-paper"

const DChip = (op) => {
    const st = op.style ? { ...op.style, margin: 3 } : { margin: 3 }
    return <Chip showSelectedCheck showSelectedOverlay  {...op} style={st}> {op.children} </Chip>

}
export default React.memo(DChip)